import React, { useState, useEffect, useCallback } from "react";

const TimeCountDown = (props) => {
  // Mốc thời gian ngày 12 tháng 12 năm 2024 - Ngày cô ấy nhận lời yêu
  const [startDate] = useState(new Date("2024-12-12T00:00:00").getTime());
  const [state, setState] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const setNewTime = useCallback(() => {
    if (startDate) {
      const currentTime = new Date().getTime();
      const distance = Math.max(0, currentTime - startDate);

      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      let minutes = Math.floor(
        (distance % (1000 * 60 * 60)) / (1000 * 60)
      );
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const numbersToAddZeroTo = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

      days = `${days}`;
      if (numbersToAddZeroTo.includes(hours)) {
        hours = `0${hours}`;
      } else if (numbersToAddZeroTo.includes(minutes)) {
        minutes = `0${minutes}`;
      } else if (numbersToAddZeroTo.includes(seconds)) {
        seconds = `0${seconds}`;
      }

      setState({ days, hours: `${hours}`, minutes: `${minutes}`, seconds: `${seconds}` });
    }
  }, [startDate]);

  useEffect(() => {
    const interval = setInterval(() => setNewTime(), 1000);
    return () => clearInterval(interval);
  }, [setNewTime]);

  return (
    <div className="react-countdown">
      <div className="time-section">
        <div className="time">{state.days || "0"}</div>
        <small className="time-text">Ngày</small>
      </div>
      <div className="time-section">
        <div className="time">{state.hours || "00"}</div>
        <small className="time-text">Giờ</small>
      </div>
      <div className="time-section">
        <div className="time">{state.minutes || "00"}</div>
        <small className="time-text">Phút</small>
      </div>
      <div className="time-section">
        <div className="time">{state.seconds || "00"}</div>
        <small className="time-text">Giây</small>
      </div>
    </div>
  );
};

export default TimeCountDown;
